import api from "../api/axios";
import type { LoginResponse } from "../types/models";

export const authService = {
    async login(email: string, password: string) {
        const response = await api.post<LoginResponse>("/auth/login", { email, password });
        return response.data.data; // return { user, subscription, token }
    },

    logout() {
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        localStorage.removeItem("user");
        localStorage.removeItem("subscription");
    },

    getCurrentUser() {
        return {
            token: localStorage.getItem("token"),
            role: localStorage.getItem("role"),
            user: JSON.parse(localStorage.getItem("user") || "null"),
            subscription: JSON.parse(localStorage.getItem("subscription") || "null"),
        };
    },
};
